export default "__VITE_ASSET__5208f00e__"